<div>
  <div class="form-title">
    <span> {{ formTitle() }}</span>
  </div>
  <div class="input-containers">
    <!-- Camera input -->
    @if (!disableVideoInput() && cameras().length) {
      <div>
        <mat-form-field class="welcome-custom-select-input">
          <mat-label>Camera</mat-label>
          <mat-select [value]="selectedCamera()?.deviceId" name="camera">
            @for (camera of cameras(); track camera.deviceId) {
              <mat-option [value]="camera.deviceId" (click)="setCamera(camera)">{{
                camera.label || 'Camera ' + ($index + 1)
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (disableVideoInput() || !cameras().length) {
      <div>
        <mat-form-field
          class="welcome-custom-select-input"
          [ngClass]="{ 'permission-denied-input': disableVideoInput() && videoPermissionDenied() }"
        >
          <mat-label>Camera</mat-label>
          @if (videoPermissionDenied()) {
            <mat-icon [matTooltip]="'Camera access permission denied'" matSuffix>info</mat-icon>
          }
          <mat-select [(value)]="defaultSelected" name="camera" disabled>
            @if (videoPermissionDenied()) {
              <mat-option value="default" selected>Browser permissions needed</mat-option>
            }
            @if (disableVideoInput()) {
              <mat-option value="default" selected>Select camera</mat-option>
            }
            @if (!cameras().length) {
              <mat-option value="default" selected>No camera detected</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- Microphone input-->
    @if (!disableMicInput() && mics().length) {
      <div>
        <mat-form-field class="welcome-custom-select-input">
          <mat-label>Microphone</mat-label>
          <mat-select [value]="selectedMic()?.deviceId" name="mic">
            @for (mic of mics(); track mic.deviceId) {
              <mat-option [value]="mic.deviceId" (click)="setMic(mic)">{{
                mic.label || 'Microphone ' + ($index + 1)
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    @if (disableMicInput() || !mics().length) {
      <div>
        <mat-form-field
          class="welcome-custom-select-input"
          [ngClass]="{ 'permission-denied-input': disableMicInput() && audioPermissionDenied() }"
        >
          <mat-label>Microphone</mat-label>
          @if (audioPermissionDenied()) {
            <mat-icon matTooltip="Microphone access permission denied." matSuffix>info</mat-icon>
          }
          <mat-select [(value)]="defaultSelected" name="mic" disabled>
            @if (audioPermissionDenied()) {
              <mat-option value="default" selected>Browser permissions needed</mat-option>
            }
            @if (disableMicInput()) {
              <mat-option value="default" selected>Select microphone</mat-option>
            }
            @if (!mics().length) {
              <mat-option value="default" selected>No microphone detected</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- Speaker input-->
    @if (!disableMicInput() && speakers().length) {
      <div>
        <mat-form-field class="welcome-custom-select-input">
          <mat-label>Speaker</mat-label>
          <mat-select [value]="selectedSpeaker()?.deviceId" name="speaker">
            @for (speaker of speakers(); track speaker.deviceId) {
              <mat-option [value]="speaker.deviceId" (click)="setSpeaker(speaker)">{{
                speaker.label || 'Speaker ' + ($index + 1)
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (disableMicInput() || !speakers().length) {
      @if (disableMicInput() || !speakers().length) {
        <div>
          <mat-form-field
            class="welcome-custom-select-input"
            [ngClass]="{ 'permission-denied-input': disableMicInput() && audioPermissionDenied() }"
          >
            <mat-label>Speaker</mat-label>
            @if (audioPermissionDenied()) {
              <mat-icon matTooltip="Audio access permission denied." matSuffix>info</mat-icon>
            }
            <mat-select [(value)]="defaultSelected" name="speaker" disabled>
              @if (audioPermissionDenied()) {
                <mat-option value="default" selected>Browser permission needed</mat-option>
              }
              @if (disableMicInput()) {
                <mat-option value="default" selected>Select speaker</mat-option>
              }
              @if (!speakers().length) {
                <mat-option value="default" selected>No speaker detected</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    }

    @if (!hideRoomSelectionInput()) {
      <div>
        <mat-form-field
          class="welcome-custom-select-input"
          [ngClass]="{ 'permission-denied-input': disableMicInput() && audioPermissionDenied() }"
        >
          <mat-label>Enter room</mat-label>
          <mat-select [disabled]="!canUserJoin()" [value]="disableMicInput() ? 'default' : selectedRoom()" name="room">
            @if (audioPermissionDenied()) {
              <mat-option value="default" selected>Browser permission needed</mat-option>
            }
            @if (disableMicInput()) {
              <mat-option value="default" selected>Select room</mat-option>
            }
            @for (room of connectedRoomSet(); track room.socialId) {
              <mat-option [value]="room.socialId" [disabled]="isConnectedRoomFull(room)" (click)="onRoomChange(room)">
                {{ room.name }} - {{ isConnectedRoomFull(room) ? '(Full)' : getRoomPopulationText(room) }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
</div>
